import { render } from "./IconSearch.vue.js?vue&type=template&id=61c51575!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconSearch.vue?vue&type=template&id=61c51575"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__